module.exports = __webpack_public_path__ + "img/cp.98957d7e.png";